// Lib Imports
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'grommet';
import { Copy as CopyIcon } from 'grommet-icons';
import { useToast } from 'granite-admin/core/components/Toast';
const Copy = ({
  value,
  size,
  successMsg,
  toolTip,
  icon,
  children
}) => {
  const {
    successToast
  } = useToast();
  if (children) {
    return /*#__PURE__*/React.createElement(Button, {
      onClick: () => {
        navigator.clipboard.writeText(value);
        successToast(successMsg);
      }
    }, children, icon && /*#__PURE__*/React.createElement(CopyIcon, {
      margin: "small",
      color: "brand",
      size: size
    }));
  } else return /*#__PURE__*/React.createElement(Button, {
    align: "center",
    tip: toolTip,
    icon: /*#__PURE__*/React.createElement(CopyIcon, {
      color: "brand",
      size: size
    }),
    onClick: () => {
      navigator.clipboard.writeText(value);
      successToast(successMsg);
    }
  });
};
Copy.defaultProps = {
  size: 'small',
  successMsg: 'Text copied to clipboard',
  toolTip: 'click to copy'
};
Copy.propTypes = {
  // add your proptypes here
  value: PropTypes.string.isRequired,
  size: PropTypes.string,
  successMsg: PropTypes.string,
  toolTip: PropTypes.string,
  icon: PropTypes.bool
};
export default Copy;